 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"591aa4f098e43da3ec65","1":"162f543001dbddd1c35c","2":"feca4603b8de34cbde80","3":"f1013c96e6d896bd9275","4":"67d18bf85c0381ed4f2b","5":"7c631352cb4f979b7e8b","6":"e455a8dfc903e5d28ca4","AccountOpening":"f0986f5c92d16f97b6cf","BackTopBottom":"06571432b9a7fcdfa3d1","Caption":"60a1627126fba5abb1e9","Copyright":"dbc72ddde15c156ab11b","DataBox":"f2ed914df02936a8a36b","LivePlayer":"39a1ca2ef22bb859da22","MoreTabs":"e020ef717a7267db516f","Nav":"9c3f3cad1de5a87164bf","NormalCaption":"863f4b3e9688d51e22e1","Offline":"ddec627c9927cf990b60","Stick":"2133d882700ee42e61b5","Tip":"c5c6dea85aaa649ac96d","ViewMoreLink":"b32869c5c67c1152c7d8","WxLaunchApp":"2e68387d960181d430da","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"4a7305c602e778512e03","Atlas":"fc71e01198ed6f5b3f85","FiveNavPic":"2bf9d4a66064e53554bd","FourNavPic":"cf4b9d4e72cf9c5af2fa","vendors~MdBanner":"958c50c87aba79d0c9ef","vendors~BigImage~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~CallupVideoAppHead~HomeFo~464104dc":"7f72a1e118cd2685655b","CallupVideoAppHead":"f323a284cdbf98ee9602","HomeFooter":"43a8ba1b19070b213a83","Hongbao":"72b558af5a1e370e5f91","ThreeNavPic":"26e6301b69dd27f049c1","vendors~BigImage~BigImg~BigTopic~InformationFlow~NewsStream~OneImage~SlideImg~ThreeImage~TitleImg~Tw~9fd299ab":"da5ba3b0a1a95938f013","TwoImage":"8b6b52aff1fa0543c660","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"a958b29799cb45246464","BigImage":"ecadb57f7050f2174c92","OneImage":"f0c73bd824cf03ae30f8","ThreeImage":"bd419da59e3dfd3dcc9f","vendors~NewsStream":"0173d214b9fbd1e6fe31","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"4e80d82bf1a5f1c799bb","TwoImg":"d417b31172400f9e3d1b","InformationFlow":"f657f4d84f2d0191f674","vendors~BigImg":"d42c00c8563330e0d8f1","BigImg":"6f521e7a31df69af27e5","vendors~BigTopic~TitleImg":"12473e8eb067d2e8ec9e","BigTopic":"4e11c66a4a37e30f6336","TitleImg":"edf41e23e84c2b123bd4","vendors~SlideImg":"a7064c0c66dc152ee1c8","NoImage":"4a58a7d3a4d0a951b72b","SingleTitle":"9b04f9c7e44688ed7d90","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"6b98600ead0ade0789e4","NormalSlides":"d3259fd85de74aa8cdf0","ShareSlides":"d7e5ef6b39a08aba7d47","vendors~BottomSlides~UpgradeBottomSlides":"c20766aef7d16e18db64","UpgradeBottomSlides":"cb5c8b2a71f4b06413d6","vendors~IndexSlides":"6dcc02d16c9391cf4e83","vendors~BrowserGuideLayer":"0ea268d367f2727356ea","vendors~CallupHead":"1ac1648b8c53ac0e3fb5","vendors~Comment~ShareComment":"cd19a87c60213087e2d1","vendors~ShareComment":"042ca1c97623572bde4e","vendors~Comment~Survey":"28af4ec1c154337e334d","vendors~Survey":"3c1aa648c62b9e46780a","vendors~NormalTabs":"d4e153d75bed59ec936f","vendors~WXGuideLayer":"ea390c094fa8bb26bfd9","vendors~Comment~LoginDialog":"8841631a794311fd0bba","vendors~Comment":"48505be1338630a845bb","Comment":"dbbc33a4307d2ef084c5","vendors~Img":"923519912cd6ea2cf468","vendors~MarkTabs":"f9c5985726fa5c1ae711","vendors~PageBottomBrand":"98072c4ba5f059441632","vendors~Player":"aebbc833a71cade72e71","Player":"22c7650ea91ccb850b2a","vendors~QQShare":"bb0708d33026d4c5962d","vendors~SimpleGuideLayer":"d6ddc3b7b8f0cf426875","vendors~SlidesTabs":"a08cbcc56858594e4f6f","vendors~pics":"aff80b89c294d447fbbb","pics":"4c32dbaef86cf982c692"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
